"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* exported Tunstall_BPU329 */

var Tunstall_BPU329_reader = function (_BleReader) {
  _inherits(Tunstall_BPU329_reader, _BleReader);

  function Tunstall_BPU329_reader() {
    _classCallCheck(this, Tunstall_BPU329_reader);

    return _possibleConstructorReturn(this, (Tunstall_BPU329_reader.__proto__ || Object.getPrototypeOf(Tunstall_BPU329_reader)).apply(this, arguments));
  }

  _createClass(Tunstall_BPU329_reader, [{
    key: "onConnect",
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setClock(new Date());

              case 2:
                return _context.abrupt("return", this.getBatteryStatus());

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onConnect(_x) {
        return _ref.apply(this, arguments);
      }

      return onConnect;
    }()
  }, {
    key: "setClock",
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(date) {
        var byte_array;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                byte_array = this.dateToArray(date);
                return _context2.abrupt("return", this.writeWithoutResponse("ff01", "ff02", byte_array.buffer));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setClock(_x2) {
        return _ref2.apply(this, arguments);
      }

      return setClock;
    }()
  }, {
    key: "dateToArray",
    value: function dateToArray(date) {
      // Format of command packet:
      // [0x02][Secs][Mins][Hours][Day][Month][Year-2000][Pad with 0x00, 13 Bytes]
      // eg 2013-5-16 9:33:51
      // 0x02 0x51 0x33 0x09 0x16 0x05 0x13 0x00 0x00 0x00 0x00 0x00 0x00 0x00 0x00 0x00 0x00 0x00 0x00 0x00
      var date_hexstring_array = ["0x02", "0x" + date.getSeconds(), "0x" + date.getMinutes(), "0x" + date.getHours(), "0x" + date.getDate(), "0x" + (date.getMonth() + 1), "0x" + (date.getFullYear() - 2000)];

      for (var i = 0; i < 13; i++) {
        date_hexstring_array.push("0x00");
      }

      var array = new Uint8Array(date_hexstring_array.length);
      for (i = 0; i < date_hexstring_array.length; i++) {
        array[i] = parseInt(date_hexstring_array[i]);
      }

      return array;
    }
  }]);

  return Tunstall_BPU329_reader;
}(BleReader);

var Tunstall_BPU329 = new JS.Class(BLE_Device, {
  initialize: function initialize(device_uuid) {
    var name = "Tunstall BPU329";
    var model_name = "BPU329";
    //device_uuid = device_uuid; //"F8:66:6C:AC:C1:7A";
    var service_uuid = "1810";
    var measurement_uuids = ["2a35", "2a36"];
    this.advertised_name = "BloodPressureDevice";
    return this.callSuper(name, model_name, device_uuid, service_uuid, measurement_uuids);
  },

  _decode_result: function _decode_result(result, reader) {
    var result_byte_array = new Uint8Array(result);

    var flags = this._decode_flag_byte(result_byte_array[0]);

    var date = new Date();
    if (flags.hasTimestamp) {
      var zero_pad = kanayo.util.zero_pad_integer;

      date = new Date(zero_pad(result_byte_array[8] * 256 + result_byte_array[7], 4) + "-" + zero_pad(result_byte_array[9], 2) + "-" + zero_pad(result_byte_array[10], 2) + "T" + zero_pad(result_byte_array[11], 2) + ':' + zero_pad(result_byte_array[12], 2) + ':' + zero_pad(result_byte_array[13], 2));
      var userTimezoneOffset = new Date().getTimezoneOffset() * 60000;
      date = new Date(date.getTime() + userTimezoneOffset);

      console.log("Date from BPC: " + date);
    }
    if (flags.hasBP && flags.hasPulse) {

      var pressure_systolic = kanayo.util.combine_bytes_for_integer([result_byte_array[2], result_byte_array[1]], false);
      var pressure_diastolic = kanayo.util.combine_bytes_for_integer([result_byte_array[4], result_byte_array[3]], false);
      var mean_arterial_pressure = kanayo.util.combine_bytes_for_integer([result_byte_array[6], result_byte_array[5]], false);
      var pulse_rate = kanayo.util.combine_bytes_for_integer([result_byte_array[15], result_byte_array[14]], false);
      //var measurement_status =  kanayo.util.combine_bytes_for_integer([result_byte_array[18], result_byte_array[17]], false);

      return {
        valid: true,
        batteryStatus: this.batteryStatus,
        date: date,
        readings: [{ main: true,
          measurements: [{ name: "hr", value: "" + pulse_rate, unit: 'bpm', designations: [] }, { name: "sbp", value: "" + pressure_systolic, unit: 'mmhg', designations: [] }, { name: "dbp", value: "" + pressure_diastolic, unit: 'mmhg', designations: [] }, { name: "map", value: "" + mean_arterial_pressure, unit: 'mmhg', designations: [] }]
        }]
      };
    } else if (flags.hasBP) {
      pressure_systolic = kanayo.util.combine_bytes_for_integer([result_byte_array[2], result_byte_array[1]], false);
      return { valid: false, progress: { message: "" + pressure_systolic, settingsOnly: true } };
    } else {
      return { valid: false, readings: [] };
    }
  },

  _decode_flag_byte: function _decode_flag_byte(status_byte) {
    var bit_string = status_byte.toString(2);
    //Make sure byte string is 8 bits by padding MSBs with zeros
    while (bit_string.length < 8) {
      bit_string = "0" + bit_string;
    }

    return {
      hasBP: bit_string[7] == "0",
      hasTimestamp: bit_string[6] == "1",
      hasPulse: bit_string[5] == "1",
      hasUserId: bit_string[4] == "1",
      hasStatus: bit_string[3] == "1"
    };
  },

  makeReader: function makeReader() {
    return new Tunstall_BPU329_reader(this);
  }

});